import { useState } from 'react';
import './App.css';
import Hero_score from './components/Hero_score';
import About from './components/About';
import Team from './components/Team';
import Subunits from './components/Subunits';
import Navbar from './layouts/NavBar';
import Events from './components/events/Events';
import NotFound from './layouts/NotFound';
import ReloaderPage from './layouts/Reloader';
import Join from './components/Join';
import GalleryCarousel from './components/GalleryCarousel';
import CircuitDivider from './components/CircuitDivider';
import AboutTeamDivider from './components/AboutTeamDivider';
import QuoteDivider from './components/QuoteDivider';
import AboutUsPage from './components/AboutUsPage';
import TeamPage from './components/TeamPage';
import SubunitsPage from './components/SubunitsPage';
import ContactPage from './components/ContactPage';
import Footer from './layouts/Footer';

import Awards from './components/Awards';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Contact from './components/Contact';
import ScrollToTop from './components/ScrollToTop';

import { Toaster } from 'react-hot-toast';
import JoinPage from './components/JoinPage';
import ThankYouPage from './components/ThankYouPage';
import AdminDashboard from './components/AdminDashboard';
import UnitRegisterPage from './components/UnitRegisterPage';
import UnitAdminDashboard from './components/UnitAdminDashboard';

function App() {
  const [showLoader, setShowLoader] = useState(true);

  return (
    <>
      {showLoader && <ReloaderPage onComplete={() => setShowLoader(false)} />}
      <div className={`transition-opacity  duration-300 ${showLoader ? 'opacity-0' : 'opacity-100'}`}>
        <Router>
        <ScrollToTop/> 
        <Toaster position="top-center" />
          <Navbar />
          <Routes>
            {/* Home page with Hero + About + Team + Subunits */}
            <Route 
              path="/" 
              element={
                <>
                  <Hero_score />
                  <About /> {/* Under Hero */}
                  <AboutTeamDivider /> {/* Divider between About and Team */}
                  <Team />  {/* Under About */}
                  <CircuitDivider/>
                  <Subunits /> {/* Under Team */}
                  <QuoteDivider /> {/* Divider before Gallery */}
                  <GalleryCarousel />

<div className="-mt-24 relative z-20">
  <Contact />
</div>

                </>
              } 
            />

            {/* Other pages */}
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/subunits" element={<SubunitsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/events" element={<Events />} />
            <Route path="/join" element={<JoinPage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/awards" element={<Awards />} />
            
            {/* Subunit Register Pages */}
            <Route path="/csregister" element={<UnitRegisterPage unit="cs" />} />
            <Route path="/iasregister" element={<UnitRegisterPage unit="ias" />} />
            <Route path="/ies-pesregister" element={<UnitRegisterPage unit="ies-pes" />} />
            <Route path="/wieregister" element={<UnitRegisterPage unit="wie" />} />
            <Route path="/sightregister" element={<UnitRegisterPage unit="sight" />} />
            <Route path="/smcregister" element={<UnitRegisterPage unit="smc" />} />
            <Route path="/rasregister" element={<UnitRegisterPage unit="ras" />} />

            {/* Subunit Admin Pages */}
            <Route path="/csadmin" element={<UnitAdminDashboard unit="cs" />} />
            <Route path="/iasadmin" element={<UnitAdminDashboard unit="ias" />} />
            <Route path="/ies-pesadmin" element={<UnitAdminDashboard unit="ies-pes" />} />
            <Route path="/wieadmin" element={<UnitAdminDashboard unit="wie" />} />
            <Route path="/sightadmin" element={<UnitAdminDashboard unit="sight" />} />
            <Route path="/smcadmin" element={<UnitAdminDashboard unit="smc" />} />
            <Route path="/rasadmin" element={<UnitAdminDashboard unit="ras" />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </Router>
      </div>
    </>
  );
}

export default App;
